const config = {
  slugs: {
    tools: "/produkt/utstyr/",
    recipe: "/produkt/oppskrifter/",
    yarn: "/produkt/garn/",
    booklet: "/produkt/hefter/"
  }
} as const;

export default config;
